import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {TerminalsBankJob} from "../interface/terminals-Bank-job";
import {ReceivablesBankJob} from "../interface/receivables-bank-job";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first, take} from "rxjs/operators";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class ReceivablesBankJobService {
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<ReceivablesBankJob>>
    = new ReplaySubject<CountedAndPaginated<ReceivablesBankJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object, subject?: Subject<CountedAndPaginated<ReceivablesBankJob>>): void {
    this.httpClient.get(`/rest/crm/receivables-bank-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<TerminalsBankJob>) => {
        if (subject) {
          subject.next(result);
        } else {
          this.jobListSubject.next(result);
        }
      });
  }

  public downloadBankFile(jobId: string): void {
    this.document.location.href = `/rest/crm/receivables-bank-job/${jobId}/downloadFile`;
  }

  public generate(): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/receivables-bank-job`, {})
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public deleteBankFIle(uuid: string): Observable<Uuid>  {
    return this.httpClient.delete(`/rest/crm/receivables-bank-job/${uuid}`)
      .pipe(first()) as Observable<Uuid>;
  }
}
